import * as React from 'react';
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';

type SettingsSectionProps = {
  title: string;
  description?: string;
  footer?: React.ReactNode;
  children?: React.ReactNode;
  /** Submits when the footer's primary button is a submit, keeping Enter working. */
  onSubmit?: (event: React.FormEvent<HTMLFormElement>) => void;
};

export const SettingsSection = ({
  title,
  description,
  footer,
  children,
  onSubmit,
}: SettingsSectionProps) => {
  const body = (
    <>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        {description ? <CardDescription>{description}</CardDescription> : null}
      </CardHeader>

      {children ? <CardContent>{children}</CardContent> : null}
      {footer ? <CardFooter>{footer}</CardFooter> : null}
    </>
  );

  return (
    <Card>{onSubmit ? <form onSubmit={onSubmit}>{body}</form> : body}</Card>
  );
};
